import { Expenditure } from './../../shared/user.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef, Output } from '@angular/core';
import { User, AccountSubHeadDetails } from '../../shared/user.model';
import { Search } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { EventEmitter } from 'selenium-webdriver';

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.css']
})
export class TransactionComponent implements OnInit {
  formSubmitted: boolean;
  accountHead: any={};
  as:any={};
  //expenditureId: number;
  expenditureId: any;
  mode: any;

  maintitle="FundManagement";
  title = "Add Transaction";
  Expenditure:any={};
  accountHeads: any=[];
  accountSubHeads: any=[];
  data: any;
  Formdiable : any;
  officeList: any=[];
  constructor(private userService: RegistrationService,private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler) { 
    
  }

  ngOnInit() {
    // this.route.params.subscribe(params => {
    //   this.mode = params['mode'];
    //   this.expenditureId = params["expenditureId"];
    //   this.accountHead = params["accountHead"];
    // });

    //From URL
    this.mode=localStorage.getItem('mode');
    this.expenditureId= localStorage.getItem('ExpenditureId');
    this.accountHead = localStorage.getItem('AccountHead');
    localStorage.removeItem('accounthead'); 
    localStorage.removeItem('mode');
    
    
    if (this.expenditureId!= null && this.accountHead!=null && this.mode!=null) 
    {
      this.onAccountHeadChange(this.accountHead);
      this.GetexpenditureById(this.expenditureId);
    }
    if (this.mode == 'edit')
    {
      this.title = "Edit Transaction";
    }
    if (this.mode == 'view')
    {
      this.title = "View Transaction";
    }
    this.GetAllAccountHeadValues();
    this.GetAllOfficeNames();
  }
  keyPress(event: any) {
    const pattern = /[0-9\+\.\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    // console.log(inputChar, e.charCode);
       if (!pattern.test(inputChar)) {
       // invalid character, prevent input
           event.preventDefault();
      }
 } 
 GetexpenditureById(expenditureId)
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getexpenditureById(expenditureId)
      .subscribe(
        (data:any) => {
          this.Expenditure = data; 
          console.log(this.Expenditure);
          this.Expenditure.TransactionDate = ((this.Expenditure.TransactionDate).split('T'))[0];
          this.Expenditure.InstrumentDate = ((this.Expenditure.InstrumentDate).split('T'))[0];
          this.Expenditure.AccountSubHead=data.AccountHead;
          console.log("expeid",data);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  GetAllAccountHeadValues()
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllAccountHeadValues()
    .subscribe(
      (data) => {
        this.accountHeads = data;
        console.log('Acccount Type');
        console.log(this.accountHeads);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }
  Reset(expenditureForm)
  {
    expenditureForm.reset();
  }    

  onAccountHeadChange(accountHeadValue) {  
    ;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAccountSubHeadByAccountHead(accountHeadValue)
    .subscribe(
    (data) => {
      this.accountSubHeads = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error) => {
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    }); 
  }
  UpdateExpenditure(form)
  {
    if (this.Expenditure.TransactionDate == "" || this.Expenditure.TransactionDate == null)
        swal("Warning!", "Please enter Transaction Date.", "warning");
    else if (this.Expenditure.TransactionType == null || this.Expenditure.TransactionType == "")
        swal("Warning!", "Please select Transaction Type.", "warning");
    else if (this.Expenditure.InstrumentDate == "" || this.Expenditure.InstrumentDate == null)
        swal("warning!","Please enter Instrument Date","warning");    
    else if (!(form.invalid))
    {        
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.updatExpenditure(this.Expenditure).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Transaction updated Successfully!','success');
        this.router.navigate(['/home/FundManagement']);          
        }, (error) => {
          document.getElementById('loader-spinner').style.display="none";
          this.errorHandler.HandlerError(error);
        });
    }
    else
    {
      this.formSubmitted = true;
    }
  }
  Save(form)
  { 
    if (this.Expenditure.TransactionDate == "" || this.Expenditure.TransactionDate == null)
        swal("Warning!", "Please enter Transaction Date.", "warning");      
    else if (this.Expenditure.TransactionType == null || this.Expenditure.TransactionType == "")
        swal("Warning!", "Please select Transaction Type.", "warning");
    else if (this.Expenditure.InstrumentDate == "" || this.Expenditure.InstrumentDate == null)
      swal("warning!","Please enter Instrument Date","warning");
      else if (!(form.invalid))
      {        
          document.getElementById('loader-spinner').style.display = "block";
          this.userService.addExpenditureDetails(this.Expenditure).subscribe(
          (data:any) => {
          document.getElementById('loader-spinner').style.display = "none";
          //swal('',data.Result,'success');
          swal('', 'Transaction Added Successfully!','success');
          this.router.navigate(['/home/FundManagement']);
          
        }, (error) => {
          document.getElementById('loader-spinner').style.display="none";
          this.errorHandler.HandlerError(error);
          });
        
      }
      else
      {
        this.formSubmitted = true;
      }
  }  



  GetAllOfficeNames() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllRoleNames();
    this.data.subscribe(
      (response) => {
        this.officeList = response;
        document.getElementById('loader-spinner').style.display = "none";
        //if (this.Id != null && this.mode!=null) 
         // this.GetUserForTheId(this.Id);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/finance/transaction/transaction.component.ts